import { render, staticRenderFns } from "./micrositeRegister.vue?vue&type=template&id=7f2b8e19&scoped=true"
import script from "./micrositeRegister.vue?vue&type=script&lang=js"
export * from "./micrositeRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2b8e19",
  null
  
)

export default component.exports